import React, { useState } from 'react';
import { Box } from '@mui/material';
import { GroupsRounded, SubjectRounded } from '@mui/icons-material';
import IconLabel from '@src/new-components/IconLabel';
import { COLOR } from '@src/styles/color';
import { formatNumberWithSuffix } from '@src/utils/number';
import { useTranslation } from 'react-i18next';
import i18n from '@src/languages';
import { StyledVoiceCardItem } from './index.style';
import VoiceInfo from '../VoiceInfo';
import NewVoiceAction from '../NewVoiceAction';

const VoiceCardItem = ({
  voice,
  retentionDaysLabel,
  onUseVoice,
  isPlaying,
  onPlayAudio,
  onPauseAudio,
  user,
  onUpdateFavouriteVoices,
  isDialog,
  favouriteVoiceCodes,
  onFavoriteToggleRequest,
  activeVoiceCode,
  prizes,
}) => {
  const { t } = useTranslation();
  const { language } = i18n;
  const [isHovered, setIsHovered] = useState(false);

  const getNumberWithSuffix = (number) =>
    formatNumberWithSuffix(number, language);

  const handleMouseEnter = () => setIsHovered(true);
  const handleMouseLeave = () => setIsHovered(false);

  const handlePlayOrPauseAudio = (e) => {
    if (isPlaying) {
      onPauseAudio(e);
    } else {
      onPlayAudio(e);
    }
  };

  return (
    <StyledVoiceCardItem
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={handlePlayOrPauseAudio}
      isAudioPlaying={isPlaying}
      isActive={activeVoiceCode === voice?.code && isDialog}
    >
      <Box className="voice-card-info-container">
        <Box className="voice-card-info-wrapper">
          <VoiceInfo
            voice={voice}
            isHovered={isHovered}
            retentionDaysLabel={retentionDaysLabel}
            isPlaying={isPlaying}
            onPlayAudio={onPlayAudio}
            onPauseAudio={onPauseAudio}
            prizes={prizes}
          />
        </Box>
        <Box className="voice-card-value">
          <IconLabel
            icon={
              <GroupsRounded
                sx={{ color: COLOR.indigo[64], width: 16, height: 16 }}
              />
            }
            value={getNumberWithSuffix(voice.stats?.totalUsers ?? 0)}
            tooltip={t('totalUsersUsed')}
            textVariant="body-14-regular"
          />
          <IconLabel
            icon={
              <SubjectRounded
                sx={{ color: COLOR.indigo[64], width: 16, height: 16 }}
              />
            }
            value={getNumberWithSuffix(voice.stats?.totalCredits ?? 0)}
            tooltip={t('totalCharactersConverted')}
            textVariant="body-14-regular"
          />
        </Box>
      </Box>

      <NewVoiceAction
        voiceCode={voice?.code}
        profilePage={voice?.profilePage}
        onUseVoice={onUseVoice}
        isCard
        isHovered={isHovered}
        onUpdateFavouriteVoices={onUpdateFavouriteVoices}
        favouriteVoiceCodes={favouriteVoiceCodes}
        onFavoriteToggleRequest={onFavoriteToggleRequest}
        user={user}
      />
    </StyledVoiceCardItem>
  );
};

export default VoiceCardItem;
